import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

import ToolTip from "../../ToolTip";

import "./SwitchCustom.scss";

const SwitchCustom = ({
  checked = false,
  onChange = () => {},
  leftLabel = "ENG",
  leftLabelClassName,
  rightLabel = "UA",
  rightLabelClassName,
  ariaLabel = "Switch",
  className = "",
  disabled = false,
  scale = 1,
  style,
  invertedActiveLabel = false,
  tooltipMessage = "",
}) => {
  const {t} = useTranslation();

  return (
    <ToolTip
      title={tooltipMessage}
      className={clsx("switch-custom", disabled && !invertedActiveLabel && "switch-custom--disabled", className)}
      role="group"
      aria-label={ariaLabel}
      style={{"--switch-scale": scale, ...style}}
    >
      <>
        <span
          className={clsx(
            "switch-custom__label",
            !checked && !invertedActiveLabel && "active",
            checked && invertedActiveLabel && "active",
            leftLabelClassName,
          )}
        >
          {typeof leftLabel === "string" ? t(leftLabel) : leftLabel}
        </span>

        <label className="switch-custom__toggle">
          <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
          <span className={clsx("switch-custom__slider", disabled && "blur")} />
        </label>

        <span
          className={clsx(
            "switch-custom__label",
            checked && !invertedActiveLabel && "active",
            !checked && invertedActiveLabel && "active",
            rightLabelClassName,
          )}
        >
          {typeof rightLabel === "string" ? t(rightLabel) : rightLabel}
        </span>
      </>
    </ToolTip>
  );
};

export default SwitchCustom;
